<div class="ui-fullscreen">
  <ng-content></ng-content>
</div>
